import $ from "jquery";
import 'owl.carousel';
import 'slick-carousel';
import 'magnific-popup'

$(document).ready(function () {

  $('.js-product').each(function () {

    $(this).on('click', function () {
      let $this = $(this);
      let id = $this.data('id');
      let url = $this.closest('.service-block__list').data('url');

      $.ajax({
        url: url,
        method: "GET",
        dataType: 'json',
        data: {
          id: JSON.stringify(id)
        },
        // success: function (response) {
        //   $.magnificPopup.open({
        //     items: {
        //       src: '#item-popup'
        //     },
        //     type: 'inline',
        //     callbacks: {
        //       close: function(){
        //         $('#item-popup').html('')
        //       }
        //     }
        //   });
        //   $('#item-popup').html(response.html);
        //   window.spinner();
        //   window.fav();
        //
        //   $('.product-item__slide').magnificPopup({
        //     type: 'image',
        //     mainClass: 'mfp-with-zoom',
        //     gallery:{
        //       enabled:true
        //     },
        //
        //     zoom: {
        //       enabled: true,
        //       duration: 300,
        //       easing: 'ease-in-out',
        //     }
        //
        //   });
        //
        //   $('.js-products').slick({
        //     slidesToShow: 1,
        //     slidesToScroll: 1,
        //     arrows: true,
        //     fade: true,
        //     asNavFor: '.slider-nav'
        //   });
        //
        //   $('.slider-nav').slick({
        //     slidesToShow: 3,
        //     slidesToScroll: 1,
        //     asNavFor: '.js-products',
        //     dots: false,
        //     centerMode: false,
        //     focusOnSelect: true,
        //     arrows: false,
        //     responsive: [
        //       {
        //         breakpoint: 640,
        //         settings: {
        //           slidesToShow: 2,
        //           slidesToScroll: 2,
        //         }
        //       }
        //     ]
        //   });
        // }
        complete: function (response = url) {

          $('#item-popup').html(response.responseText);
          window.spinner();
          window.fav();

          $.magnificPopup.open({
            items: {
              src: '#item-popup'
            },
            type: 'inline',
            callbacks: {
              close: function(){
                $('#item-popup').html('')
              }
            }
          });

            $('.js-products').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              fade: true,
              asNavFor: '.slider-nav'
            });

            $('.slider-nav').slick({
              slidesToShow: 3,
              slidesToScroll: 1,
              asNavFor: '.js-products',
              dots: false,
              centerMode: false,
              focusOnSelect: true,
              arrows: false,
              responsive: [
                {
                  breakpoint: 640,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                  }
                }
              ]
            });
        }
      });
    })
  })


  window.fav = function () {
    $('.js-item-fav').each(function () {
      $(this).on('click', function () {
        let idFav = $(this).closest('.product-item').data('id');
        let url = $(this).data('url');
        $.ajax({
          url: url,
          method: "GET",
          dataType: 'json',
          data: {
            id: JSON.stringify(idFav)
          },
          success: function (response) {
            if(response.success) {
              $(this).addClass('active');
            } else {
              $(this).removeClass('active');
            }
          }
        });
      })
    })
  }


  $('.open-popup-link').magnificPopup({
    type:'inline',
    midClick: true,
    removalDelay: 300,
    mainClass: 'mfp-with-zoom'
  });

  $('.js-gallery-item').magnificPopup({
    type: 'image',
    mainClass: 'mfp-with-zoom',
    gallery:{
      enabled:true
    },

    zoom: {
      enabled: true,
      duration: 300,
      easing: 'ease-in-out',
    }

  });

  $('.gallery-item').magnificPopup({
    type: 'image',
    mainClass: 'mfp-with-zoom',
    gallery:{
      enabled:true
    },

    zoom: {
      enabled: true,
      duration: 300,
      easing: 'ease-in-out',
    }

  });

  $('.diasport-gallery__slide a').magnificPopup({
    type: 'image',
    mainClass: 'mfp-with-zoom',
    gallery:{
      enabled:true
    },

    zoom: {
      enabled: true,
      duration: 300,
      easing: 'ease-in-out',
    }

  });

  $('.certificate-block__slide').magnificPopup({
    type: 'image',
    mainClass: 'mfp-with-zoom',
    gallery:{
      enabled:true
    },

    zoom: {
      enabled: true,
      duration: 300,
      easing: 'ease-in-out',
    }

  });

  $('.js-owl-carousel-diasport').owlCarousel({
    smartSpeed: 500,
    items: 1,
    singleItem: true,
    responsiveClass: true,
    nav: true
  });

  $('.js-owl-carousel-videos').owlCarousel({
    smartSpeed: 500,
    items: 1,
    singleItem: true,
    responsiveClass: true,
    nav: true,
    margin:10,
    responsive : {
      480: {
        items: 2
      },
      1024: {
        items: 3
      }
    }
  });

  $('.js-owl-carousel-events').owlCarousel({
    smartSpeed: 500,
    items: 1,
    singleItem: true,
    responsiveClass: true,
    nav: true
  });

  $('.js-owl-carousel-undertop').owlCarousel({
    smartSpeed: 500,
    items: 2,
    singleItem: true,
    responsiveClass: true,
    nav: true,
    margin:10,
    responsive : {
      640: {
        items: 3,
      },
      1025: {
        items: 5,
      }
    }
  });

  function  toggleMenu () {
    $('.js-open-menu').on('click', () => {
      $('.mobile-menu').slideDown(350);
    });

    $('.js-close-menu').on('click', () => {
      $('.mobile-menu').slideUp(350);
    });

    $('.js-acnhor-item').on('click', () => {
      $('.mobile-menu').slideUp(350);
    });
  }

  toggleMenu();

  function fixedHeader () {
    let scroll = $(window).scrollTop();
    let width = $(window).width();

    if (scroll >= 100) {
      $('.header').addClass('fixed');
    } else {
      $('.header').removeClass('fixed');
    }

    if (scroll >= 300) {
      $('.header').addClass('show');
    } else {
      $('.header').removeClass('show');
    }
  }

  fixedHeader();

  $(window).scroll(function() {
    fixedHeader();
  });

  $(".js-acnhor-item").click(function() {
    $("html, body").animate({
      scrollTop: $($(this).attr("href")).offset().top + "px"
    }, {
      duration: 500,
      easing: "swing"
    });
    return false;
  });

  window.spinner = function () {
    $('.number-spinner__btn').click(function() {
      var btn = $(this),
          oldValue = btn.closest('.number-spinner').find('input').val().trim(),
          newVal = 0;

      if (btn.attr('data-dir') === 'up') {
        newVal = parseInt(oldValue) + 1;
      } else {
        if (oldValue > 1) {
          newVal = parseInt(oldValue) - 1;
        } else {
          newVal = 1;
        }
      }
      btn.closest('.number-spinner').find('input').val(newVal);
    });
    $('.number-spinner>input').keypress(function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    });
  }
});
